import { render, staticRenderFns } from "./visitMaterialListDialog.vue?vue&type=template&id=63871fb8&scoped=true"
import script from "./visitMaterialListDialog.vue?vue&type=script&lang=js"
export * from "./visitMaterialListDialog.vue?vue&type=script&lang=js"
import style0 from "./visitMaterialListDialog.vue?vue&type=style&index=0&id=63871fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63871fb8",
  null
  
)

export default component.exports